import { axiosClient } from '../axiosClient';
import type { CancelarInput, ModoCobranca, Recorrencia } from '@/types/recorrencia.types';

// Cobrança recorrente do produtor (área finance da API).

export const recorrenciaApi = {
  obter: async (userId: number): Promise<Recorrencia> =>
    (await axiosClient.get(`/admin/users/${userId}/recorrencia`)).data,

  gerarFatura: async (
    userId: number
  ): Promise<{ criada: boolean; link_pagamento: string | null }> =>
    (await axiosClient.post(`/admin/users/${userId}/recorrencia/fatura`)).data,

  reenviar: async (faturaId: number): Promise<{ enfileirada: boolean }> =>
    (await axiosClient.post(`/admin/faturas/${faturaId}/reenviar`)).data,

  cancelar: async (userId: number, dados: CancelarInput) =>
    (await axiosClient.post(`/admin/users/${userId}/recorrencia/cancelar`, dados)).data,

  atualizar: async (
    userId: number,
    dados: { modo_cobranca?: ModoCobranca; whatsapp_cobranca?: boolean }
  ): Promise<Recorrencia> =>
    (await axiosClient.patch(`/admin/users/${userId}/recorrencia`, dados)).data,
};
